'use strict';
module.exports = [
  '$scope',
  '$uibModalInstance',
  'channelsService',
  'situationRecord',
  function ($scope, $uibModalInstance, channelsService, situationRecord) {
    $scope.situationRecord = situationRecord;

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.yes = function () {
      $uibModalInstance.close($scope.selectedChannels);
    };

    $scope.channelList = [];
    $scope.selectedChannels = [];

    channelsService.findAll(function (channels) {
      $scope.channelList = channels;

      if ($scope.situationRecord.channels) {
        for (var i = 0; i < $scope.situationRecord.channels.length; i++) {
          $scope.selectedChannels.push($scope.situationRecord.channels[i]);
        }
      }
    });

    $scope.checkIfChannelIsPresent = function (channel) {
      if ($scope.selectedChannels) {
        for (var i = 0; i < $scope.selectedChannels.length; i++) {
          if ($scope.selectedChannels[i].id == channel.id) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.addOrRemoveChannel = function (channel) {
      if ($scope.selectedChannels) {
        for (var i = 0; i < $scope.selectedChannels.length; i++) {
          if ($scope.selectedChannels[i].id == channel.id) {
            $scope.selectedChannels.splice(i, 1);
            return;
          }
        }
      }

      if (!$scope.selectedChannels) {
        $scope.selectedChannels = [];
      }

      $scope.selectedChannels.push(channel);
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/modal/modalChannelsCtrl.js
// module id = 243
// module chunks = 0